import axios, { AxiosError, AxiosResponse } from 'axios';
import authService from '@/authentication/authentication.service';

export class BaseApiClient {
			public send<T, U>(
				method: HttpVerb,
				url: string,
				data: T = {} as T,
				responseType: 'text' | 'document' | 'arraybuffer' | 'blob' | 'json' | 'stream' | undefined = 'text'
			): Promise<U> {
				// if (!authService.isAuthenticated()) {
				// 	//authService.login();
				// 	return Promise.reject("Not logged in");
				// }

				return authService.getToken().then((token: string | null) => {
					const headers = {
						Authorization: `Bearer ${token}`
					};

					// NOTE: we are expecting responses to be in json, but our APIs return errors as strings in the body,
					// so to read those we need to expect responseType to be 'text'. Fortunately due to a quirk with axios,
					// they try and parse responses as json even if you set responseType to text, so currently this is working
					// well for us. In future, we should ensure all errors are returned by APIs as json, not strings and then
					// set the responseType to 'json
					return axios(url, {
						method,
						data,
						headers,
						responseType,
					})
						.then((response) => {
							if (response.status >= 200 && response.status <= 202) {
								try {
									return JSON.parse(response.data);
								} catch {
									return response.data;
								}
							}
							return {};
						})
						.catch((err: AxiosError) => {
							if (err.response) {
								return this.handleError(err.response);
							}
							return Promise.reject({
								status: -1,
								message: err.message,
							} as ApiError);
						});
				});
			}

			private handleError(response: AxiosResponse) {
				let message = '';
				let status = -1;
				if (response) {
					status = response.status;
					if (response.data) {
						message = response.data;
					} else if (response.statusText) {
						message = `Request failed with status ${response.statusText}`;
					} else {
						message = `Request failed with status code ${response.status}`;
					}
				} else {
					message = `There was a problem contacting our servers.`;
				}
				return Promise.reject({
					status,
					message,
				} as ApiError);
			}
		}

export interface ApiError {
	status: number;
	message: string;
}

export const api = new BaseApiClient();

export type HttpVerb = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS' | 'HEAD';
